import { type ClassValue, clsx } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

/*
 * O `tailwind-merge` só reconhece como tamanho de fonte os degraus de fábrica
 * do Tailwind. A escala do GEF tem degraus que ele não conhece (`text-2xs`,
 * `text-md`) e cores com nome próprio (`text-link`, `text-foreground`); sem
 * esta lista, ele toma `text-md` por cor e descarta um dos dois ao juntar
 * `text-md text-foreground`. A lista acompanha o `--text-*` de global.css.
 */
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      text: ['2xs', 'xs', 'sm', 'base', 'md', 'lg', 'xl', '2xl', '3xl', '4xl'],
    },
  },
})

/** Combina classes condicionais resolvendo conflitos do Tailwind. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
